import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MenuItem } from 'primeng/primeng';
import { BaseComponent } from './base.component';
import { MensagensPadrao, CabecalhoMensagens } from './use-system/enums/Enumarations';

@Component({ template: '' })
export class BaseCrudComponent extends BaseComponent {
    cadastro: FormGroup;
    obj: any;

    filtro: FormGroup;

    id: number;
    acao: string;

    showEtapas: boolean = false;

    disableAutoLoad: boolean = false;

    etapa: number = 0;
    etapas: MenuItem[] = [
        { label: 'Dados' },
        { label: 'Resumo' }
    ];

    dateValidation: RegExp = /(((\d{4})-(\d{2})-(\d{2})T(\d{2})\:(\d{2})\:(\d{2}))([+-](\d{2})\:(\d{2}))?Z?z?)/;

    /**
     * Variavel responsavel por identificar se a funcionalidade usa navegação customizada.
     */
    customValidator: boolean = false;
    /**
     * Objeto usado para realizar a validação em multiplos níveis em uma telas, deve ser definido na classe que extende o base-crud.
     */
    multiValidator = {
        cadastro: this.cadastro,
        isValid: false,
        /**
         * Metodo a ser definido na implementação do multiValidator;
         */
        emitValidation: (isInit: any) => this.emitValidation(isInit)
    };

    ngOnInit() {
        this.ngProgress.start();
        this.ngProgress.done();
        this.init();

        this.activatedRoute.params.subscribe(params => {
            this.id = params['id'];
            var listaLink = location.href.split("/");
            var caminho = listaLink[5] + '/' + listaLink[6];
            if (caminho === "turma/editar") {
                this.acao = 'turma-editar';
            } else if (caminho === "turma/prestar-conta") {
                this.acao = 'turma-prestar-conta'
            }
            else if (caminho === "gerenciar-servico-gestor/encaminhar") {
                this.acao = 'encaminhar'
            }
            else {
                this.acao = (params['acao'] !== undefined ? params['acao'] : "cadastrar").toLowerCase();
            }
            switch (this.acao) {
                case 'visualizar':
                    this.etapa = (this.etapas.length - 1);
                    this.cadastro.disable();
                case 'editar':
                    this.loadObject();
                    break;
                case 'enviar-cadastro':
                    this.etapa = this.etapas.length;
                case 'analisar':
                    this.etapa = this.etapas.length;
                case 'alterar-responsavel':
                    this.loadObject();
                    break;
                case 'turma-prestar-conta':
                    this.loadObject();
                    break;
                case 'turma-editar':
                    this.loadObject();
                    break;
                case 'encaminhar':
                    this.loadObject();
                    break;
            }
        });
        this.afterLoad();
    };

    /**
     * Método que carrega os dados do back-end e preenche o form de maneira correspondente.
     */
    loadObject() {
        if (!this.disableAutoLoad) {
            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.Obter(this.controllerName, this.id).subscribe(obj => {
                Object.keys(obj).forEach(key => {
                    obj[key] = this.dateValidation.test(obj[key]) ? new Date(obj[key]) : obj[key];
                });
                this.obj = obj;
                this.cadastro.patchValue(obj);
                /**
                 * Metodo sobrescrito.
                 * Só será executado caso a ação seja diferente de cadastrar. Deve ser implementado na classe filha.
                 */
                this.afterInit();
            },
                err => {
                    this.showMsgError(`${MensagensPadrao[22]} ${err._body}`);
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                },
                () => this.observableUtilPanelDoc.setBlockedPanel(false));
        };
    }

    /**
     * Método que contém ações simples ao realizar a persistencia de um dado, pode ser sobrescrito caso seja necessário realizar alguma ação no método doFinalAction sem ser necessário sobrescrever toda a ação.
     * @param data retorno da service
     */
    dataAction(data?: any) {
        this.acao == 'cadastrar' ?
            this.router.navigate(['../'], { relativeTo: this.activatedRoute }) :
            this.router.navigate(['../../'], { relativeTo: this.activatedRoute })
    }

    removeEspacos(valor: string) {
        return valor.replace(/ +/g, ' ').trim();
    }

    doFinalAction(obj: any, route: string = null, parcial?: any, hasValue = 0, message: number = 0) {
        this.confirmacao.confirm({
            header: CabecalhoMensagens[1],
            message: `Atenção! Ao confirmar esta operação, os dados serão ${this.acao == 'cadastrar' ? 'salvos' : 'atualizados'} na base de dados.<br>Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.acao === 'cadastrar' && hasValue === 0 ?
                    this.service.Adicionar(route == null ? this.controllerName : route, obj).subscribe(
                        data => {
                            this.dataAction(data);
                            this.showMsgSucess(MensagensPadrao[1]);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            super.showMsgWarn(`Houve um erro ao salvar o registro.<br> ${err._body}`)
                        },
                        () => { this.observableUtilPanelDoc.setBlockedPanel(false); }) :
                    this.service.Atualizar(route == null ? this.controllerName : route, obj, parcial).subscribe(
                        data => {
                            this.dataAction(data);
                            this.showMsgSucess(MensagensPadrao[2]);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            super.showMsgWarn(`Houve um erro ao atualizar o registro.<br> ${err._body}`)
                        },
                        () => { this.observableUtilPanelDoc.setBlockedPanel(false); });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/base/base-crud.component.ts